<header class="content-header">
  <h4 #trigger class="vision-h4">{{ cloneView ? 'Clone' : '' }} {{ data.taskRow.taskId }}</h4>
  <fw-popover action="mouseenter" position="below" [trigger]="trigger">
    <div class="padding-15">
      @if (taskDetails) {
        <div class="task-definition">
          <strong class="title"
            >Task {{ taskDetails.reader_task.item_number }} / {{ taskDetails.reader_task.batch_total_tasks }}</strong
          >
          <strong>Container Filter</strong>
          <div class="tags-group">
            <span>Contains tag(s)</span>
            @if (taskTagContainers.include.tags.length > 0) {
              <fw-tags
                test-id="task-includes-tags"
                [container]="$any(taskTagContainers.include)"
                [useAsInlineField]="true"
                [writable]="false"
              />
            } @else {
              <span><i>None</i></span>
            }
          </div>
          <div class="tags-group">
            <span>Does NOT contain tag(s)</span>
            @if (taskTagContainers.exclude.tags.length > 0) {
              <fw-tags
                test-id="task-excludes-tags"
                [container]="$any(taskTagContainers.exclude)"
                [useAsInlineField]="true"
                [writable]="false"
              />
            } @else {
              <span><i>None</i></span>
            }
          </div>
        </div>
      } @else {
        <span>Loading...</span>
      }
    </div>
  </fw-popover>
  <span class="project-context" test-id="project-context">
    {{ 'Project' | titlecase }}: {{ data.taskRow.projectLabel }}
  </span>
  @if (canDownloadFiles) {
    <mat-icon fwTooltip="Download Associated File" (click)="$event.stopPropagation(); downloadTaskFiles(data.taskRow)"
      >cloud_download
    </mat-icon>
  }
  @if (!cloneView) {
    <button color="primary" mat-flat-button test-id="view-task" (click)="viewTask()">Launch In Viewer</button>
  }
</header>
<div mat-dialog-content>
  <div class="immutable-details fw-well">
    <div class="detail">
      <span class="title">Task Type</span>
      <span class="detail-value" test-id="task-type">{{ data.taskRow.taskType }}</span>
    </div>
    <div class="detail">
      <span class="title">Read Protocol</span>
      @if (data.taskRow.protocol) {
        <span class="detail-value" test-id="read-protocol" [fwTooltip]="data.taskRow.protocol?.description">
          {{ data.taskRow.protocol.label }}
        </span>
      } @else {
        <span class="detail-value" test-id="no-protocol">None</span>
      }
    </div>
    <div class="detail">
      <span class="title">Container</span>
      <fw-ellipsis
        class="detail-value"
        test-id="container"
        [text]="data.taskRow.container.label || ''"
        [tooltip]="data.taskRow.container.hierarchy"
      />
    </div>
    @if (!cloneView) {
      <div class="detail">
        <span class="title">Task Creator</span>
        <span class="detail-value" test-id="creator">
          @if (data.taskRow.creator) {
            <app-avatar [users]="data.taskRow.creator" />
            <span>{{ data.taskRow.creator.firstname }} {{ data.taskRow.creator.lastname }}</span>
          } @else {
            <span>Unknown</span>
          }
        </span>
      </div>
    }
  </div>
  <div class="flex-container">
    <form class="editable-details" [formGroup]="formGroup">
      <div class="half-width">
        <label aria-label="Assignee"> Assignee </label>
        <div class="mat-form-field">
          <app-typeahead
            class="solid-background full-width"
            formControlName="assignee"
            placeholder="Assignee"
            test-id="user-typeahead"
            [options]="users"
          />
          @if (formGroup.controls.assignee.hasError('required')) {
            <mat-error> Assignee is required </mat-error>
          }
        </div>
      </div>

      <div class="half-width">
        <label aria-label="Date Due"> Date Due </label>
        <mat-form-field appearance="outline" class="date-field flex-field">
          <input
            autocomplete="off"
            formControlName="dueDate"
            matInput
            placeholder="Select Date"
            test-id="due-date-input"
            [matDatepicker]="datepicker"
          />
          <mat-datepicker-toggle class="xs" test-id="due-date-picker-toggle" [for]="datepicker">
            <mat-icon class="xs" matDatepickerToggleIcon>event</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #datepicker />
          @if (formGroup.controls.dueDate.hasError('required')) {
            <mat-error> Date Due is required. </mat-error>
          }
          @if (formGroup.controls.dueDate.hasError('pastDate')) {
            <mat-error> Date Due must be a future date. </mat-error>
          }
        </mat-form-field>
      </div>

      @if (!cloneView) {
        <div class="half-width">
          <label aria-label="Status"> Status </label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="status" test-id="status">
              @for (status of statusOptions; track status) {
                <mat-option [value]="status.value">{{ status.display }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }

      <div class="half-width">
        <label aria-label="Task Tags"> Task Tags </label>
        <fw-tags
          formControlName="tags"
          test-id="task-tags"
          [allowCustomTags]="true"
          [autoSave]="false"
          [container]="tagContainer"
          [useAsInlineField]="true"
        />
      </div>
    </form>

    @if (!cloneView) {
      @if (taskDetails) {
        <mat-tab-group animationDuration="0ms" class="tabs-white content-body" mat-stretch-tabs="false">
          <mat-tab label="Form Data">
            <ng-template matTabContent>
              @if (formData.data.length) {
                <mat-table class="data-table" [dataSource]="formData">
                  <ng-container matColumnDef="question">
                    <mat-cell *matCellDef="let element">
                      <strong [attr.test-id]="'question-label-' + element.key">{{ element.label }}</strong>
                      <span class="grey" [attr.test-id]="'question-key-' + element.key">{{ element.key }}</span>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="response">
                    <mat-cell *matCellDef="let element">
                      <span
                        class="response"
                        [attr.test-id]="'response-label-' + element.key"
                        [innerHTML]="element.response ? element.response : '-'"
                      ></span>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="error">
                    <mat-cell *matCellDef="let element" colspan="2">
                      <strong test-id="form-data-error-header">See Viewer for Form Data</strong>
                      <span class="grey" test-id="form-data-error-message"
                        >There is a slice specific workflow set up for this task. Please launch in viewer to review this
                        data on each slice.</span
                      >
                    </mat-cell>
                  </ng-container>
                  @if (!isSliceSpecificWorkflow) {
                    <mat-row *matRowDef="let element; columns: ['question', 'response']" />
                  }
                  @if (isSliceSpecificWorkflow) {
                    <mat-row *matRowDef="let element; columns: ['error']" />
                  }
                </mat-table>
              } @else {
                <div class="empty blank-state">
                  <mat-icon class="sm raised blue">search</mat-icon>
                  <p>No response data exists for this form.</p>
                </div>
              }
            </ng-template>
          </mat-tab>
          <mat-tab label="Annotation Data">
            <ng-template matTabContent>
              @if (annotationData.data.length) {
                <mat-table class="data-table" [dataSource]="annotationData">
                  <ng-container matColumnDef="question">
                    <mat-cell *matCellDef="let element">
                      <strong [attr.test-id]="'question-label-' + element.key">{{ element.label }}</strong>
                      <span class="grey" [attr.test-id]="'question-key-' + element.key">{{ element.key }}</span>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="response">
                    <mat-cell *matCellDef="let element">
                      <span
                        class="response"
                        fwTooltip="Count of annotations by label and tool type"
                        [attr.test-id]="'response-label-' + element.key"
                        [innerHTML]="element.response ? element.response : '-'"
                      ></span>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="error">
                    <mat-cell *matCellDef="let element" colspan="2">
                      <strong test-id="annotation-data-error-header">See Viewer for Annotation Data</strong>
                      <span class="grey" test-id="annotation-data-error-message"
                        >There is a slice specific workflow set up for this task. Please launch in viewer to review this
                        data on each slice.</span
                      >
                    </mat-cell>
                  </ng-container>
                  @if (!isSliceSpecificWorkflow) {
                    <mat-row *matRowDef="let element; columns: ['question', 'response']" />
                  }
                  @if (isSliceSpecificWorkflow) {
                    <mat-row *matRowDef="let element; columns: ['error']" />
                  }
                </mat-table>
              } @else {
                <div class="empty blank-state">
                  <mat-icon class="sm raised blue">search</mat-icon>
                  <p>No annotations have been added to this task.</p>
                </div>
              }
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      } @else {
        <div class="blank-state content-body" test-id="loading-state">
          <img src="/assets/images/loading.svg" style="margin-bottom: 10px" />
          <p>Loading Task Details...</p>
        </div>
      }
    }
  </div>
</div>

<div align="end" class="action-buttons" mat-dialog-actions>
  @if (!cloneView) {
    <a test-id="view-related-tasks-link" (click)="viewRelatedTasks()">View Related Tasks</a>
    @if (isReaderTaskAdmin) {
      <button mat-dialog-close mat-stroked-button test-id="cancel-button">Cancel</button>
      <button mat-stroked-button test-id="delete-button" (click)="deleteTask()">Delete</button>
      <button mat-stroked-button test-id="clone-button" (click)="showCloneView(true)">Clone</button>
      <button
        color="primary"
        mat-flat-button
        test-id="save-button"
        [disabled]="formGroup.invalid || !formGroup.dirty"
        (click)="submit()"
      >
        Save Changes
      </button>
    } @else {
      <button mat-dialog-close mat-stroked-button test-id="close-button">Close</button>
    }
  } @else {
    <button mat-stroked-button test-id="cancel-clone-button" (click)="showCloneView(false)">Cancel</button>
    <button
      color="primary"
      mat-flat-button
      test-id="clone-button"
      [disabled]="formGroup.invalid"
      (click)="createClone()"
    >
      Clone
    </button>
  }
</div>
